import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, Protected } from "@/lib/auth";
import { MarketProvider } from "@/lib/market";
import { PublicLayout, DashLayout } from "@/components/Layouts";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import Compare from "@/pages/Compare";
import ContentPage, { InstallPage } from "@/pages/ContentPage";
import { Login, Signup, Forgot, Reset, VerifyEmail } from "@/pages/Auth";
import Overview from "@/pages/dash/Overview";
import Saved from "@/pages/dash/Saved";
import Enquiries from "@/pages/dash/Enquiries";
import EnquiryDetail from "@/pages/dash/EnquiryDetail";
import MyListings from "@/pages/dash/MyListings";
import ListingWizard from "@/pages/dash/ListingWizard";
import ListingManage from "@/pages/dash/ListingManage";
import Account, { Onboarding } from "@/pages/dash/Account";
import { Tasks, Fees, MyReports, Notifications } from "@/pages/dash/Misc";
import { ReviewerCases, ReviewerCase } from "@/pages/Reviewer";
import AdminOverview from "@/pages/admin/AdminOverview";
import { AdminUsers, AdminAudit } from "@/pages/admin/AdminPeople";
import { AdminListings, AdminListingDetail, AdminVerification } from "@/pages/admin/AdminListings";
import { AdminModeration, AdminDeals } from "@/pages/admin/AdminOps";
import AdminFees from "@/pages/admin/AdminFees";
import AdminReports from "@/pages/admin/AdminReports";
import AdminContent from "@/pages/admin/AdminContent";
import Registration from "@/pages/dash/Registration";
import { AdminRegistrations, AdminPayments, AdminPricing } from "@/pages/admin/AdminRegistrations";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <MarketProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/category/:category" element={<Browse />} />
              <Route path="/city/:city" element={<Browse />} />
              <Route path="/business/:slug" element={<ListingDetail />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/page/:slug" element={<ContentPage />} />
              <Route path="/install" element={<InstallPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<Forgot />} />
              <Route path="/reset-password" element={<Reset />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
            </Route>
            <Route element={<Protected><DashLayout /></Protected>}>
              <Route path="/dashboard" element={<Overview />} />
              <Route path="/dashboard/onboarding" element={<Onboarding />} />
              <Route path="/dashboard/saved" element={<Saved />} />
              <Route path="/dashboard/enquiries" element={<Enquiries />} />
              <Route path="/dashboard/enquiries/:id" element={<EnquiryDetail />} />
              <Route path="/dashboard/listings" element={<MyListings />} />
              <Route path="/dashboard/listings/:id" element={<ListingManage />} />
              <Route path="/dashboard/listings/:id/edit" element={<ListingWizard />} />
              <Route path="/dashboard/tasks" element={<Tasks />} />
              <Route path="/dashboard/fees" element={<Fees />} />
              <Route path="/dashboard/reports" element={<MyReports />} />
              <Route path="/dashboard/notifications" element={<Notifications />} />
              <Route path="/dashboard/account" element={<Account />} />
              <Route path="/dashboard/registration" element={<Registration />} />
            </Route>
            <Route element={<Protected role="reviewer"><DashLayout /></Protected>}>
              <Route path="/reviewer" element={<ReviewerCases />} />
              <Route path="/reviewer/cases/:id" element={<ReviewerCase />} />
            </Route>
            <Route element={<Protected role="admin"><DashLayout /></Protected>}>
              <Route path="/admin" element={<AdminOverview />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/listings" element={<AdminListings />} />
              <Route path="/admin/listings/:id" element={<AdminListingDetail />} />
              <Route path="/admin/verification" element={<AdminVerification />} />
              <Route path="/admin/moderation" element={<AdminModeration />} />
              <Route path="/admin/deals" element={<AdminDeals />} />
              <Route path="/admin/fees" element={<AdminFees />} />
              <Route path="/admin/reports" element={<AdminReports />} />
              <Route path="/admin/content" element={<AdminContent />} />
              <Route path="/admin/audit" element={<AdminAudit />} />
              <Route path="/admin/registrations" element={<AdminRegistrations />} />
              <Route path="/admin/payments" element={<AdminPayments />} />
              <Route path="/admin/pricing" element={<AdminPricing />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </MarketProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
